import React from 'react'
import './CvPrint.css'
import { skillsMatrixContent } from '../skills-matrix/content'
import { careerTimelineContent } from '../timeline/content'

// QR code for https://petvalsky.com/ — version 2, ECC M, generated offline
// and verified with two independent decoders. 25×25 modules, row-run-length
// encoded into a single path.
const QR_PATH = 'M0,0h7v1h-7zM12,0h5v1h-5zM18,0h7v1h-7zM0,1h1v1h-1zM6,1h1v1h-1zM8,1h1v1h-1zM12,1h1v1h-1zM14,1h3v1h-3zM18,1h1v1h-1zM24,1h1v1h-1zM0,2h1v1h-1zM2,2h3v1h-3zM6,2h1v1h-1zM9,2h1v1h-1zM14,2h1v1h-1zM16,2h1v1h-1zM18,2h1v1h-1zM20,2h3v1h-3zM24,2h1v1h-1zM0,3h1v1h-1zM2,3h3v1h-3zM6,3h1v1h-1zM10,3h3v1h-3zM14,3h1v1h-1zM16,3h1v1h-1zM18,3h1v1h-1zM20,3h3v1h-3zM24,3h1v1h-1zM0,4h1v1h-1zM2,4h3v1h-3zM6,4h1v1h-1zM8,4h1v1h-1zM11,4h2v1h-2zM14,4h2v1h-2zM18,4h1v1h-1zM20,4h3v1h-3zM24,4h1v1h-1zM0,5h1v1h-1zM6,5h1v1h-1zM10,5h1v1h-1zM15,5h2v1h-2zM18,5h1v1h-1zM24,5h1v1h-1zM0,6h7v1h-7zM8,6h1v1h-1zM10,6h1v1h-1zM12,6h1v1h-1zM14,6h1v1h-1zM16,6h1v1h-1zM18,6h7v1h-7zM9,7h3v1h-3zM13,7h2v1h-2zM0,8h1v1h-1zM2,8h1v1h-1zM4,8h1v1h-1zM6,8h1v1h-1zM9,8h2v1h-2zM12,8h2v1h-2zM15,8h2v1h-2zM20,8h1v1h-1zM23,8h1v1h-1zM1,9h2v1h-2zM4,9h1v1h-1zM7,9h3v1h-3zM11,9h1v1h-1zM16,9h3v1h-3zM24,9h1v1h-1zM3,10h6v1h-6zM11,10h1v1h-1zM13,10h1v1h-1zM17,10h2v1h-2zM20,10h1v1h-1zM22,10h3v1h-3zM0,11h1v1h-1zM4,11h2v1h-2zM7,11h2v1h-2zM10,11h5v1h-5zM19,11h1v1h-1zM23,11h1v1h-1zM0,12h1v1h-1zM2,12h1v1h-1zM6,12h3v1h-3zM10,12h2v1h-2zM13,12h1v1h-1zM17,12h3v1h-3zM21,12h1v1h-1zM23,12h2v1h-2zM2,13h1v1h-1zM4,13h2v1h-2zM8,13h4v1h-4zM16,13h1v1h-1zM18,13h1v1h-1zM21,13h1v1h-1zM24,13h1v1h-1zM0,14h1v1h-1zM2,14h2v1h-2zM5,14h2v1h-2zM10,14h1v1h-1zM16,14h4v1h-4zM22,14h3v1h-3zM1,15h1v1h-1zM4,15h1v1h-1zM7,15h3v1h-3zM11,15h1v1h-1zM13,15h5v1h-5zM20,15h1v1h-1zM23,15h1v1h-1zM0,16h1v1h-1zM2,16h2v1h-2zM6,16h1v1h-1zM9,16h2v1h-2zM12,16h10v1h-10zM8,17h5v1h-5zM15,17h2v1h-2zM20,17h2v1h-2zM23,17h2v1h-2zM0,18h7v1h-7zM10,18h4v1h-4zM15,18h2v1h-2zM18,18h1v1h-1zM20,18h2v1h-2zM23,18h2v1h-2zM0,19h1v1h-1zM6,19h1v1h-1zM10,19h1v1h-1zM12,19h3v1h-3zM16,19h1v1h-1zM20,19h2v1h-2zM23,19h2v1h-2zM0,20h1v1h-1zM2,20h3v1h-3zM6,20h1v1h-1zM8,20h1v1h-1zM11,20h1v1h-1zM14,20h1v1h-1zM16,20h6v1h-6zM23,20h2v1h-2zM0,21h1v1h-1zM2,21h3v1h-3zM6,21h1v1h-1zM11,21h1v1h-1zM19,21h4v1h-4zM0,22h1v1h-1zM2,22h3v1h-3zM6,22h1v1h-1zM8,22h1v1h-1zM10,22h1v1h-1zM13,22h1v1h-1zM16,22h2v1h-2zM20,22h1v1h-1zM24,22h1v1h-1zM0,23h1v1h-1zM6,23h1v1h-1zM10,23h2v1h-2zM15,23h2v1h-2zM20,23h2v1h-2zM23,23h1v1h-1zM0,24h7v1h-7zM8,24h2v1h-2zM12,24h1v1h-1zM15,24h2v1h-2zM19,24h1v1h-1zM23,24h2v1h-2z'

const getLevelText = (level: number): string => {
	if (level >= 90) return 'Expert'
	if (level >= 75) return 'Advanced'
	if (level >= 60) return 'Intermediate'
	return 'Beginner'
}

const getLevelKey = (level: number): string => {
	if (level >= 90) return 'expert'
	if (level >= 75) return 'advanced'
	if (level >= 60) return 'intermediate'
	return 'beginner'
}

export const CvPrint: React.FC = () => {
	const currentYear = new Date().getFullYear()

	return (
		<div className="cv-print">
			<header className="cv-print-header">
				<img src="/avatar.webp" className="cv-print-photo" alt="Martin Bondy Pětvalský" />
				<div className="cv-print-identity">
					<h1>
						<span className="cv-print-name-first">Martin</span>
						<span className="cv-print-name-last">Bondy Pětvalský</span>
					</h1>
					<p className="cv-print-role">Fullstack Microsoft 365 Developer</p>
				</div>
				<div className="cv-print-contacts">
					<span className="cv-print-contact-row">
						Brušperk, Czechia, EU
					</span>
					<span className="cv-print-contact-row">
						+420 734 473 000
					</span>
					<span className="cv-print-contact-row">
						<a href="mailto:martin@petvalsky.com">martin@petvalsky.com</a>
					</span>
					<span className="cv-print-contact-row">
						<a href="https://www.linkedin.com/in/martinpetvalsky/">linkedin.com/in/martinpetvalsky</a>
					</span>
					<span className="cv-print-contact-row cv-print-contact-note">
						work history &amp; references
					</span>
					<span className="cv-print-contact-row cv-print-remote">
						<strong>remote only — no office, no hybrid</strong>
					</span>
				</div>
				<div className="cv-print-qr">
					<svg viewBox="0 0 25 25" role="img" aria-label="QR code linking to petvalsky.com">
						<path d={QR_PATH} fill="#111" shapeRendering="crispEdges" />
					</svg>
					<span className="cv-print-qr-cta">
						This CV is alive —<br />
						scan for the interactive version
					</span>
				</div>
			</header>

			<p className="cv-print-summary">
				I design and ship enterprise Microsoft 365 solutions end-to-end: SPFx web parts and
				Teams apps as clients, Microsoft Graph as the API hub, .NET services in AKS pods
				(Helm / Rancher / Argo CD) and Azure Functions as compute, REST/SOAP integrations to
				internal and external systems — all secured by Entra ID and delivered through CI/CD.
			</p>

			<section className="cv-print-timeline">
				<h2 className="cv-print-section-title">Career Timeline</h2>
				{careerTimelineContent.milestones.map(milestone => (
					<div key={milestone.year + milestone.title} className="cv-print-milestone">
						<span className="cv-print-milestone-year">{milestone.year}</span>
						<span className="cv-print-milestone-body">
							<strong>{milestone.title}</strong>
							{' — '}
							{milestone.description}
							{' '}
							<span className="cv-print-milestone-tags">[{milestone.tags.join(' · ')}]</span>
						</span>
					</div>
				))}
			</section>

			<section className="cv-print-skills">
				<h2 className="cv-print-section-title">Skills Matrix</h2>
				{skillsMatrixContent.categories.map(category => (
					<div key={category.name} className="cv-print-category">
						<h3 className="cv-print-category-title">{category.name}</h3>
						<div className="cv-print-skills-grid">
							{category.skills.map(skill => (
								<div key={skill.id} className="cv-print-skill">
									<div className="cv-print-skill-header">
										<span className="cv-print-skill-name">{skill.name}</span>
										<span className="cv-print-skill-exp">
											{currentYear - skill.sinceYear}y exp
										</span>
									</div>
									<div className="cv-print-bar-track">
										<div
											className="cv-print-bar-fill"
											data-level={getLevelKey(skill.level)}
											style={{ width: `${skill.level}%` }}
										/>
									</div>
									<div className="cv-print-skill-meta">
										<span>{getLevelText(skill.level)}</span>
										<span>{skill.level}%</span>
									</div>
									<p className="cv-print-skill-desc">{skill.description}</p>
									{skill.certifications && skill.certifications.length > 0 && (
										<div className="cv-print-certs">
											{skill.certifications.map(c => (
												<span key={c} className="cv-print-cert">{c}</span>
											))}
										</div>
									)}
								</div>
							))}
						</div>
					</div>
				))}
			</section>

			<footer className="cv-print-footer">
				<p>
					Work history, references &amp; project portfolio:&nbsp;
					<a href="https://www.linkedin.com/in/martinpetvalsky/">linkedin.com/in/martinpetvalsky</a>
				</p>
			</footer>
		</div>
	)
}
